let timer = null
export const debounce = (fn, time) => {
    return function () {
        if (timer) {
            timer = null
        } else {
            timer = setTimeout(fn, time)
        }
    }
}

export function addScrollEvent(dispatch) {
    const baseRef = document.getElementById(`BaseCanvasBox`)
    const compareRef = document.getElementById(`CompareCanvasBox`)
    const bindBaseFunc = () => {
        debounce(() => {
            compareRef.scrollTop = baseRef.scrollTop
            compareRef.scrollLeft = baseRef.scrollLeft
        }, 200)()
    }
    const bindCompareFunc = () => {
        debounce(() => {
            baseRef.scrollTop = compareRef.scrollTop
            baseRef.scrollLeft = compareRef.scrollLeft
        }, 200)()
    }
    const bindBase = () => {
        baseRef.addEventListener("scroll", bindBaseFunc)
    }
    const bindCompare = () => {
        compareRef.addEventListener("scroll", bindCompareFunc)
    }
    const removeBase = () => {
        baseRef.removeEventListener("scroll", bindBaseFunc)
    }
    const removeCompare = () => {
        compareRef.removeEventListener("scroll", bindCompareFunc)
    }
    baseRef.addEventListener("mouseover", bindBase)
    compareRef.addEventListener("mouseover", bindCompare)
    baseRef.addEventListener("mouseout", removeBase)
    compareRef.addEventListener("mouseout", removeCompare)
}
